import { collection, onSnapshot, query } from "firebase/firestore"
import { httpsCallable } from "firebase/functions"
import { useCallback, useEffect, useState } from "react"

import { db, functions } from "../firebase"
import type { Connection } from "../types/connectors"
import { useAuth } from "./useAuth"

const disconnectConnectionFn = httpsCallable<{ connectionId: string }, void>(
  functions,
  "disconnectConnection",
)

export function useConnections() {
  const { user } = useAuth()
  const [connections, setConnections] = useState<Connection[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (!user) {
      setConnections([])
      setLoading(false)
      return
    }

    const q = query(collection(db, "users", user.uid, "connections"))
    const unsubscribe = onSnapshot(q, (snapshot) => {
      setConnections(
        snapshot.docs.map(
          (doc) => ({ oid: doc.id, ...doc.data() }) as Connection,
        ),
      )
      setLoading(false)
    })

    return unsubscribe
  }, [user])

  const disconnect = useCallback(async (connectionId: string) => {
    await disconnectConnectionFn({ connectionId })
  }, [])

  return { connections, loading, disconnect }
}
